import { Div, Text } from "atomize"
import { motion } from "framer-motion"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBaseball, faUsers } from "@fortawesome/free-solid-svg-icons"
import { theme } from "../settings/config"

// Le due cose che il "+" sa fare, quando "Gioco io" è acceso
// (src/utils/match.utils.js): una lezione, o quando giochi tu. Sta sopra al
// "+", e sotto dice la scorciatoia — tenerlo premuto va dritto alla lezione —
// perché è l'unico posto in cui la si legge.
const ITEMS = [
	{
		key: "lesson",
		icon: faUsers,
		title: "Lezione",
		detail: "con i tuoi allievi",
		bg: "primary_light",
		iconBg: "primary",
		titleColor: "gunmetal",
	},
	{
		key: "match",
		icon: faBaseball,
		title: "Gioco io",
		detail: "giochi tu, il campo lo paghi tu",
		bg: "surface",
		iconBg: "match_fill",
		titleColor: "match_dark",
	},
]

function NewLessonMenu({ onLesson, onMatch, onClose }) {
	const actions = { lesson: onLesson, match: onMatch }

	return (
		<>
			{/* un tocco fuori chiude */}
			<Div
				pos="fixed"
				top="0"
				left="0"
				w="100vw"
				h="100vh"
				bg={theme.colors.background_blur}
				style={{ zIndex: -1 }}
				onClick={onClose}
			/>
			<motion.div
				initial={{ opacity: 0, y: 8, scale: 0.97 }}
				animate={{ opacity: 1, y: 0, scale: 1 }}
				transition={{ duration: 0.15 }}
				style={{
					position: "absolute",
					right: 0,
					bottom: "calc(100% + 0.5rem)",
					width: "16rem",
					transformOrigin: "bottom right",
				}}>
				<Div
					role="menu"
					aria-label="Nuova"
					p="0.5rem"
					rounded="20px"
					bg={theme.colors.surface}
					shadow={theme.shadows["top-3"]}
					d="flex"
					flexDir="column"
					style={{ gap: "0.25rem" }}>
					{ITEMS.map(item => (
						<Div
							key={item.key}
							tag="button"
							type="button"
							role="menuitem"
							d="flex"
							align="center"
							p="0.75rem"
							rounded="14px"
							border="0"
							cursor="pointer"
							textAlign="left"
							bg={theme.colors[item.bg]}
							style={{ gap: "0.75rem", font: "inherit" }}
							onClick={actions[item.key]}>
							<Div
								w="2.5rem"
								h="2.5rem"
								rounded="12px"
								bg={theme.colors[item.iconBg]}
								d="flex"
								align="center"
								justify="center"
								style={{ flexShrink: 0 }}>
								<FontAwesomeIcon icon={item.icon} color={theme.colors.white} />
							</Div>
							<Div>
								<Text
									textSize="subheader"
									textWeight="bold"
									textColor={theme.colors[item.titleColor]}>
									{item.title}
								</Text>
								<Text textSize="caption" textColor={theme.colors.text_light}>
									{item.detail}
								</Text>
							</Div>
						</Div>
					))}
					<Text
						textSize="tiny"
						textColor={theme.colors.text_light}
						textAlign="center"
						p={{ t: "0.25rem", b: "0.15rem" }}>
						Tieni premuto + per andare dritto alla lezione
					</Text>
				</Div>
			</motion.div>
		</>
	)
}

export default NewLessonMenu
